import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: '关于我们' },
  ];

  const stats = [
    { number: '5000+', label: '爆料文章', icon: 'ri-article-line' },
    { number: '100万+', label: '月访问量', icon: 'ri-user-line' },
    { number: '50+', label: '合作媒体', icon: 'ri-building-line' },
    { number: '365天', label: '全年更新', icon: 'ri-calendar-check-line' },
  ];

  const faqs = [
    {
      question: '91吃瓜网的内容来源可靠吗？',
      answer: '我们所有内容均经过多轮核实，尽量确保信息的真实性。部分爆料来源于知情人士、内部工作人员及相关当事人的陈述。我们会标注信息来源，并持续跟进事件进展。',
    },
    {
      question: '如何向91吃瓜网投稿爆料？',
      answer: '您可以通过页面底部的联系方式向我们提供线索。请尽量提供详实的信息和证据材料，我们的编辑团队会在核实后决定是否发布。所有爆料者信息将严格保密。',
    },
    {
      question: '网站内容涉及侵权怎么办？',
      answer: '如果您认为本站内容侵犯了您的合法权益，请通过邮箱联系我们的法务团队。我们将在收到投诉后48小时内进行审核，确认侵权内容将立即下架处理。',
    },
    {
      question: '91吃瓜网的更新频率是怎样的？',
      answer: '我们承诺每日更新，平均每日发布30-50篇新鲜爆料。重大突发事件会第一时间跟进报道，确保网友们能够及时获取最新资讯。',
    },
    {
      question: '如何在91吃瓜网投放广告？',
      answer: '我们提供多种广告合作方案，包括banner广告、软文植入、专题合作等。有意向的广告主可以通过页面底部的商务邮箱联系我们的广告团队。',
    },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <header>
        <Navbar />
      </header>
      <main>
        {/* Page Header */}
        <section className="pt-24 md:pt-28 pb-8 md:pb-12 px-4 md:px-8 lg:px-12 bg-background-100 border-b border-background-200">
          <div className="max-w-4xl mx-auto">
            <Breadcrumb items={breadcrumbItems} />
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mt-6">
              关于91吃瓜网
            </h1>
          </div>
        </section>

        {/* Brand Introduction */}
        <section className="py-12 md:py-16 px-4 md:px-8 lg:px-12">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12 items-center">
              <div>
                <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
                  品牌介绍
                </span>
                <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-4">
                  国内领先的八卦爆料资讯平台
                </h2>
                <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                  <p>
                    91吃瓜网成立于2020年，是国内最具影响力和公信力的八卦爆料资讯平台之一。我们专注于娱乐圈内幕、明星动态、社会热点等领域的深度报道和独家爆料。
                  </p>
                  <p>
                    我们的团队由资深娱记、调查记者和行业分析师组成，致力于挖掘事件背后的真相，为网友提供第一手、最真实的资讯内容。
                  </p>
                  <p>
                    经过多年的发展，91吃瓜网已经积累了超过5000篇优质爆料文章，月访问量突破100万人次，成为国内吃瓜网友获取资讯的首选平台。
                  </p>
                </div>
              </div>
              <div className="relative">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20professional%20newsroom%20workspace%20with%20multiple%20computer%20monitors%20showing%20social%20media%20feeds%2C%20warm%20ambient%20lighting%2C%20sleek%20minimal%20desk%20setup%2C%20coffee%20cup%20and%20notebook%2C%20editorial%20photography%20style%2C%20warm%20earth%20tones%2C%20soft%20natural%20light%20from%20window&width=600&height=500&seq=about-brand&orientation=portrait"
                  alt="91吃瓜网团队"
                  className="w-full rounded-2xl object-cover"
                  width="600"
                  height="500"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-12 md:py-16 px-4 md:px-8 lg:px-12 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-background-50 rounded-xl p-5 md:p-6 text-center border border-background-200"
                >
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mx-auto mb-3">
                    <i className={`${stat.icon} text-lg md:text-xl`} />
                  </div>
                  <div className="text-xl md:text-2xl font-bold text-foreground-900 mb-1">
                    {stat.number}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Reputation */}
        <section className="py-12 md:py-16 px-4 md:px-8 lg:px-12">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10 md:mb-12">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
                网站信誉
              </span>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-3">
                真实、及时、客观的爆料平台
              </h2>
              <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
                我们始终坚持新闻真实性原则，所有爆料均经过严格核实
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {[
                {
                  icon: 'ri-shield-check-line',
                  title: '信息核实',
                  desc: '每条爆料至少经过3轮独立核实，确保信息来源可靠、内容真实准确',
                  color: 'primary',
                },
                {
                  icon: 'ri-time-line',
                  title: '及时更新',
                  desc: '7×24小时不间断更新，重大事件第一时间发布，让网友永远快人一步',
                  color: 'accent',
                },
                {
                  icon: 'ri-scales-3-line',
                  title: '客观中立',
                  desc: '坚持客观报道立场，不偏袒任何一方，让事实说话，给公众完整真相',
                  color: 'secondary',
                },
              ].map((item) => {
                const colorMap: Record<string, { bg: string; text: string }> = {
                  primary: { bg: 'bg-primary-100', text: 'text-primary-500' },
                  accent: { bg: 'bg-accent-100', text: 'text-accent-500' },
                  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-500' },
                };
                const colors = colorMap[item.color];
                return (
                  <div
                    key={item.title}
                    className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200"
                  >
                    <div className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg ${colors.bg} ${colors.text} mb-4`}>
                      <i className={`${item.icon} text-lg md:text-xl`} />
                    </div>
                    <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section id="faq" className="py-12 md:py-16 px-4 md:px-8 lg:px-12 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10 md:mb-12">
              <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
                常见问题
              </span>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900">
                您可能想了解的问题
              </h2>
            </div>
            <div
              className="space-y-4"
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200"
                  itemScope
                  itemType="https://schema.org/Question"
                >
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-3" itemProp="name">
                    {faq.question}
                  </h3>
                  <div itemScope itemType="https://schema.org/Answer">
                    <p className="text-sm text-foreground-500 leading-relaxed" itemProp="text">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section id="contact" className="py-12 md:py-16 px-4 md:px-8 lg:px-12">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10 md:mb-12">
              <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
                联系我们
              </span>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-3">
                与91吃瓜网取得联系
              </h2>
              <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
                如果您有任何问题、建议或合作意向，欢迎通过以下方式联系我们
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {[
                {
                  icon: 'ri-mail-line',
                  title: '商务合作',
                  value: 'hello@jinchenai.com',
                  desc: '广告投放、品牌合作',
                },
                {
                  icon: 'ri-article-line',
                  title: '内容投稿',
                  value: 'hello@jinchenai.com',
                  desc: '爆料投稿、线索提供',
                },
                {
                  icon: 'ri-customer-service-line',
                  title: '用户反馈',
                  value: 'hello@jinchenai.com',
                  desc: '问题反馈、投诉建议',
                },
              ].map((contact) => (
                <div
                  key={contact.title}
                  className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200 text-center"
                >
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mx-auto mb-4">
                    <i className={`${contact.icon} text-lg md:text-xl`} />
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-1">{contact.title}</h3>
                  <p className="text-sm text-primary-500 font-medium mb-2">{contact.value}</p>
                  <p className="text-xs text-foreground-400">{contact.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Disclaimer */}
        <section id="disclaimer" className="py-12 md:py-16 px-4 md:px-8 lg:px-12 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <div className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200">
              <h2 className="text-lg md:text-xl font-bold text-foreground-900 mb-4 flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center text-primary-500">
                  <i className="ri-alert-line" />
                </span>
                免责声明
              </h2>
              <div className="space-y-3 text-sm text-foreground-500 leading-relaxed">
                <p>
                  1. 91吃瓜网（以下简称"本站"）所发布的内容仅供娱乐参考，部分内容来源于网络及网友投稿，不代表本站观点或立场。
                </p>
                <p>
                  2. 本站致力于为用户提供最新、最热的八卦爆料资讯，但不对内容的绝对真实性作出任何保证。用户在浏览本站内容时应保持理性判断，自行甄别信息真伪。
                </p>
                <p>
                  3. 如涉及侵权内容，请相关权利人及时联系本站，我们将在核实后第一时间删除相关内容。
                </p>
                <p>
                  4. 本站所有内容版权归91吃瓜网所有，未经授权禁止转载、摘编或用于商业用途。
                </p>
                <p>
                  5. 用户使用本站服务即视为同意本免责声明的全部内容。本站保留随时修改免责声明的权利。
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}